import { Injectable } from '@angular/core';
import { PartnerPendingService } from './partner-pending.service';

@Injectable({ providedIn: 'root' })
export class PartnerPendingResolver {
  constructor(private partnerPendingService: PartnerPendingService) {}

  resolve() {
    return this.partnerPendingService.fetchPartnersPending();
  }
}
